import React from 'react'
import { ICatalogWithPaginationContext } from './CatalogWithPagination-types'

// @ts-ignore
const initialCatalogWithPaginationContext: ICatalogWithPaginationContext = {}
export const CatalogWithPaginationContext = React.createContext(initialCatalogWithPaginationContext)
